import React, { useRef, useEffect } from 'react';
import ReactSelect from 'react-select';

import PropTypes from 'prop-types';

import { useField } from '@unform/core';

import { Label } from './styles';

export default function Select({
  size,
  name,
  labelSelect,
  defaultValue,
  ...rest
}) {
  // Estilo do select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px solid rgba(255,255,255,0.17)',
      backgroundColor: '#323a4e',
      zIndex: '999',
      color: state.isSelected ? '#FFF' : '#dee2e6',
      padding: 15,
      outline: 'none',
    }),
    input: provided => ({
      ...provided,
      color: '#dee2e6',
    }),
    control: provided => ({
      ...provided,
      backgroundColor: '#323a4e',
      border: '1px solid rgba(255, 255, 255, 0.07)',
      color: '#FFF',
      minHeight: 50,
      marginBottom: 8,
      '&:hover': {
        borderColor: 0,
      },
    }),
    placeholder: provided => ({
      ...provided,
      color: '#dee2e6',
    }),
    singleValue: provided => ({
      ...provided,
      color: '#FFF',
      '&:focus': {
        outline: 0,
      },
    }),
  };

  const selectRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: 'state.value',
      getValue: ref => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map(option => option.value);
        }
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
    });
  }, [defaultValue, fieldName, registerField, rest.isMulti]);

  return (
    <Label size={size}>
      <strong>{labelSelect}</strong>
      <ReactSelect
        defaultValue={defaultValue}
        value={defaultValue}
        ref={selectRef}
        styles={customStyles}
        classNamePrefix="react-select"
        {...rest}
      />
      <span>{error}</span>
    </Label>
  );
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  labelSelect: PropTypes.string.isRequired,
  size: PropTypes.bool,
  // defaultValue: PropTypes.number,
};

Select.defaultProps = {
  // defaultValue: null,
  size: false,
};
